// ============================================================================
// fileUpload — envio de arquivo pelo link assinado do servidor (/api/files)
// ============================================================================
// O servidor confere a sessão e o papel, devolve um link de envio de uso único
// e o arquivo vai direto pro Storage. Ninguém mais grava no bucket com a chave
// pública (02/10/2026).
// ============================================================================

import { sessionToken } from './secureRest.js';

async function filesApi(body) {
  const token = sessionToken();
  if (!token) throw new Error('Sessão expirada. Entre de novo para enviar o arquivo.');
  const r = await fetch('/api/files', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'x-session-token': token },
    body: JSON.stringify(body),
  });
  const j = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(j.error || `Falha (HTTP ${r.status})`);
  return j;
}

// kind: 'photo' | 'unit-cover' | 'branding' | 'finance'. Retorna a URL pública
// (mídia) ou a referência privada 'private:finance/...' (comprovante).
export async function uploadViaServer(kind, id, blob) {
  // Alguns sistemas mandam PDF/foto sem tipo — deduz pela extensão.
  const byExt = { pdf: 'application/pdf', jpg: 'image/jpeg', jpeg: 'image/jpeg', png: 'image/png', webp: 'image/webp', heic: 'image/heic' };
  const ext = String(blob?.name || '').split('.').pop().toLowerCase();
  const contentType = blob?.type || byExt[ext] || 'application/octet-stream';
  const j = await filesApi({ op: 'upload', kind, id, contentType });
  const up = await fetch(j.uploadUrl, {
    method: 'PUT',
    headers: { 'Content-Type': contentType },
    body: blob,
  });
  if (!up.ok) throw new Error(`Upload falhou: ${(await up.text()).slice(0, 160)}`);
  return j.publicUrl || j.ref;
}

// Comprovante: referência nova ('private:finance/...') ou URL pública antiga
// do bucket professionals/finance/ (os arquivos foram movidos pro privado).
export function isFinanceAttachment(url) {
  return /^private:finance\//.test(String(url || '')) || /\/professionals\/finance\//.test(String(url || ''));
}

// Abre o comprovante numa aba nova com link assinado de curta duração. A aba é
// aberta ANTES do await (senão o bloqueador de pop-up do navegador barra).
export async function openFinanceAttachment(url) {
  const win = window.open('', '_blank');
  try {
    const j = await filesApi({ op: 'view', ref: url });
    if (win) win.location.href = j.url; else window.location.href = j.url;
  } catch (err) {
    if (win) win.close();
    alert(`Não foi possível abrir o comprovante: ${err?.message || err}`);
  }
}
